import Vue from 'vue'
import Router from 'vue-router'

import HomeBase from '@/components/home/HomeBase'
import MemberBase from '@/components/member/MemberBase'
import SellerBase from '@/components/seller/SellerBase'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '',
      redirect: '/home/index',
      meta: {
        footer: {
          show: true
        }
      }
    }, {
      path: '/discountCoupon',
      name: 'discountCoupon',
      component: resolve => (require(['@/components/discountCoupon/index'], resolve)),
      meta: { footer: { show: false } }
    }, {
      path: '/reelCenter',
      name: 'reelCenter',
      component: resolve => (require(['@/components/reelCenter/index'], resolve)),
      meta: { footer: { show: false } }
    }, {
      path: '/explain',
      name: 'explain',
      component: resolve => (require(['@/components/explain/index'], resolve)),
      meta: { footer: { show: false } }
    }, {
      path: '/videoCenter',
      name: 'videoCenter',
      component: resolve => (require(['@/components/videoCenter/index'], resolve)),
      meta: { footer: { show: false } }
    }, {
      path: '/videoDetail',
      name: 'videoDetail',
      component: resolve => (require(['@/components/videoCenter/detail'], resolve)),
      meta: { footer: { show: false } }
    }, {
      path: '/voucher',
      name: 'voucher',
      component: resolve => (require(['@/components/voucher/index'], resolve)),
      meta: { footer: { show: false } }
    },
    {
      path: '/orderSharing',
      name: 'orderSharing',
      component: resolve => (require(['@/components/xieyi/orderSharing'], resolve)),
      meta: { footer: { show: false } }
    },
    {
      path: '/privacyPolicy',
      name: 'privacyPolicy',
      component: resolve => (require(['@/components/xieyi/privacyPolicy'], resolve)),
      meta: { footer: { show: false } }
    },
    {
      path: '/userLogon',
      name: 'userLogon',
      component: resolve => (require(['@/components/xieyi/userLogon'], resolve)),
      meta: { footer: { show: false } }
    },
    //配置测试模块
    {
      path: '/test/index',
      name: 'tindex',
      component: resolve => (require(['@/components/test/index'], resolve)),
      meta: { footer: { show: false } }
    },
    {
      path: '/test/tindex',
      name: 'tindex',
      component: resolve => (require(['@/components/test/tindex'], resolve)),
      meta: { footer: { show: false } }
    },
    {
      path: '/test/tindex2',
      name: 'tindex',
      component: resolve => (require(['@/components/test/tindex2'], resolve)),
      meta: { footer: { show: false } }
    },
    {
      path: '/test/tindex3',
      name: 'tindex3',
      component: resolve => (require(['@/components/test/tindex3'], resolve)),
      meta: { footer: { show: false } }
    },
    //甲子商城银联权益平台权益兑换H5页面-代金券方面
    {
      path: '/jzuniqy/uniqyh5',
      name: 'uniqyh5',
      component: resolve => (require(['@/components/jzuniqy'], resolve)),
      meta: { footer: { show: false } }
    },
    //甲子商城银联权益平台权益兑换H5页面-实物订单1分购方面
    {
      path: '/jzuniqy/orderh5',
      name: 'orderh5',
      component: resolve => (require(['@/components/jzuniqy/jzuni_order'], resolve)),
      meta: { footer: { show: false } }
    },
    //甲子商城银联权益平台权益兑换H5页面-实物订单1分购方面-支付同步通知页面
    {
      path: '/jzuniqy/unipayreturn',
      name: 'orderh5',
      component: resolve => (require(['@/components/jzuniqy/jzuni_order_retrunpay'], resolve)),
      meta: { footer: { show: false } }
    },
    //甲子商城银联权益平台权益兑换H5页面-实物订单1分购方面-银联跳转支付页面
    {
      path: '/jzuniqy/orderh5pay',
      name: 'orderh5',
      component: resolve => (require(['@/components/jzuniqy/jzuni_order_pay'], resolve)),
      meta: { footer: { show: false } }
    },
    //甲子商城银联权益平台权益兑换H5页面-实物订单1分购方面-查看订单详情
    {
      path: '/jzuniqy/orderh5detail',
      name: 'orderh5detail',
      component: resolve => (require(['@/components/jzuniqy/jzuni_order_detail'], resolve)),
      meta: { footer: { show: false } }
    },
    
    {
      path: '/home/',
      component: HomeBase,
      children: [
        // 首页
        { path: 'index', name: 'HomeIndex', component: resolve => (require(['@/components/home/index/Index'], resolve)), meta: { footer: { show: true } } },
        // 地图
        { path: 'map', name: 'HomeMap', component: resolve => (require(['@/components/home/map/Map'], resolve)), meta: { footer: { show: true } } },
        // 注册协议
        { path: 'document', name: 'HomeDocument', component: resolve => (require(['@/components/home/article/Document'], resolve)), meta: { footer: { show: true } } },
        // 文章分类
        { path: 'article_class', name: 'HomeArticleclass', component: resolve => (require(['@/components/home/article/Articleclass'], resolve)), meta: { footer: { show: true } } },
        // 文章列表
        { path: 'article_list', name: 'HomeArticlelist', component: resolve => (require(['@/components/home/article/Articlelist'], resolve)), meta: { footer: { show: true } } },
        // 文章详情
        { path: 'article_detail', name: 'HomeArticledetail', component: resolve => (require(['@/components/home/article/Articledetail'], resolve)), meta: { footer: { show: true } } },
        // 活动列表
        { path: 'activity_list', name: 'HomeActivitylist', component: resolve => (require(['@/components/home/activity/Activitylist'], resolve)), meta: { footer: { show: true } } },
        // 活动详情
        { path: 'activity_detail', name: 'HomeActivitydetail', component: resolve => (require(['@/components/home/activity/Activitydetail'], resolve)), meta: { footer: { show: true } } },
        // 用户注册
        { path: 'memberregister', name: 'HomeMemberRegister', component: resolve => (require(['@/components/home/memberregister/Register'], resolve)), meta: { footer: { show: true } } },
        // 用户绑定
        { path: 'memberbind', name: 'HomeMemberBind', component: resolve => (require(['@/components/home/memberbind/Bind'], resolve)), meta: { footer: { show: true } } },
        // 用户登录
        { path: 'memberlogin', name: 'HomeMemberLogin', component: resolve => (require(['@/components/home/memberlogin/Login'], resolve)), meta: { footer: { show: true } } },
        // 卖家登录
        { path: 'sellerlogin', name: 'HomeSellerLogin', component: resolve => (require(['@/components/home/sellerlogin/Login'], resolve)), meta: { footer: { show: true } } },
        // 忘记密码
        { path: 'memberforget', name: 'HomeMemberForget', component: resolve => (require(['@/components/home/memberforget/Forget'], resolve)), meta: { footer: { show: true } } },
        // 分类
        { path: 'goodsclass', name: 'HomeGoodsclass', component: resolve => (require(['@/components/home/goodsclass/Goodsclass'], resolve)), meta: { footer: { show: true } } },
        // 店铺分类
        { path: 'storeclass', name: 'HomeStoreclass', component: resolve => (require(['@/components/home/storeclass/Storeclass'], resolve)), meta: { footer: { show: true } } },
        // 品牌
        { path: 'brand', name: 'HomeBrand', component: resolve => (require(['@/components/home/brand/Brand'], resolve)), meta: { footer: { show: true } } },
        // 购物车
        { path: 'cart', name: 'HomeCart', component: resolve => (require(['@/components/home/cart/Cart'], resolve)), meta: { footer: { show: true } } },
        // 搜索
        { path: 'search', name: 'HomeSearch', component: resolve => (require(['@/components/home/search/Search'], resolve)), meta: { footer: { show: true } } },
        // 店铺列表
        { path: 'storelist', name: 'HomeStorelist', component: resolve => (require(['@/components/home/storelist/Storelist'], resolve)), meta: { footer: { show: true } } },
        // 店铺详情
        { path: 'storedetail', name: 'HomeStoredetail', component: resolve => (require(['@/components/home/storedetail/Storedetail'], resolve)), meta: { footer: { show: false } } },
        // 店铺地图
        { path: 'storemap', name: 'HomeStoremap', component: resolve => (require(['@/components/home/storedetail/Storemap'], resolve)), meta: { footer: { show: false } } },
        // 店铺介绍
        { path: 'storeabout', name: 'HomeStoreabout', component: resolve => (require(['@/components/home/storeabout/Storeabout'], resolve)), meta: { footer: { show: false } } },
        // 店铺代金券
        { path: 'storevoucher', name: 'HomeStoreVoucher', component: resolve => (require(['@/components/home/storedetail/StoreVoucher'], resolve)), meta: { footer: { show: false } } },
        // 店铺列表
        { path: 'goodslist', name: 'HomeGoodslist', component: resolve => (require(['@/components/home/goodslist/Goodslist'], resolve)), meta: { footer: { show: true } } },
        // 店铺商品列表
        { path: 'store_goodslist', name: 'HomeStoreGoodslist', component: resolve => (require(['@/components/home/storegoodslist/Goodslist'], resolve)), meta: { footer: { show: false } } },
        // 店铺搜索
        { path: 'store_goodsclass', name: 'HomeStoreGoodsclass', component: resolve => (require(['@/components/home/storegoodsclass/Goodsclass'], resolve)), meta: { footer: { show: false } } },
        // 商品详情
        { path: 'goodsdetail', name: 'HomeGoodsdetail', component: resolve => (require(['@/components/home/goodsdetail/Goodsdetail'], resolve)), meta: { footer: { show: false } } },
        // 商品咨询
        { path: 'goodsconsult', name: 'HomeGoodsConsult', component: resolve => (require(['@/components/home/goodsdetail/GoodsConsult'], resolve)), meta: { footer: { show: false } } },
        // 拼团列表
        { path: 'pintuan_list', name: 'HomePintuanList', component: resolve => (require(['@/components/home/pintuan/PintuanList'], resolve)), meta: { footer: { show: true } } },
        // 积分兑换商品
        { path: 'pointsgoods', name: 'HomePointsgoods', component: resolve => (require(['@/components/home/pointsgoods/Index'], resolve)), meta: { footer: { show: true } } },
        // 积分兑换商品详情页
        { path: 'pointsgoods_detail', name: 'HomePointsgoodsDetail', component: resolve => (require(['@/components/home/pointsgoods/Detail'], resolve)), meta: { footer: { show: false } } },
        // 红包兑换商品详情页
        { path: 'bonus_detail', name: 'HomeBonusDetail', component: resolve => (require(['@/components/home/bonus/Detail'], resolve)), meta: { footer: { show: false } } },
        // 积分活动列表
        { path: 'marketmanagelist', name: 'HomeMarketmanagelist', component: resolve => (require(['@/components/home/marketmanage/Marketmanagelist'], resolve)), meta: { footer: { show: false } } },
        // 刮刮卡
        { path: 'marketcard', name: 'HomeMarketcard', component: resolve => (require(['@/components/home/marketmanage/Marketcard'], resolve)), meta: { footer: { show: false } } },
        // 生肖翻翻看
        { path: 'marketzodiac', name: 'HomeMarketzodiac', component: resolve => (require(['@/components/home/marketmanage/Marketzodiac'], resolve)), meta: { footer: { show: false } } },
        // 大转盘
        { path: 'marketwheel', name: 'HomeMarketwheel', component: resolve => (require(['@/components/home/marketmanage/Marketwheel'], resolve)), meta: { footer: { show: false } } },
        // 砸金蛋
        { path: 'marketegg', name: 'HomeMarketegg', component: resolve => (require(['@/components/home/marketmanage/Marketegg'], resolve)), meta: { footer: { show: false } } },
        // 砍价列表页
        { path: 'bargain_list', name: 'HomeBargainlist', component: resolve => (require(['@/components/home/bargain/Bargainlist'], resolve)), meta: { footer: { show: true } } },
        // 砍价分享页面
        { path: 'bargain_share', name: 'HomeBargainshare', component: resolve => (require(['@/components/home/bargain/Bargainshare'], resolve)), meta: { footer: { show: true } } },
        // 可编辑页面
        { path: 'special', name: 'HomeSpecial', component: resolve => (require(['@/components/home/special/Index'], resolve)), meta: { footer: { show: true } } },
        // 可编辑页面
        { path: 'store_special', name: 'HomeStoreSpecial', component: resolve => (require(['@/components/home/storespecial/Index'], resolve)), meta: { footer: { show: false } } },
        // 抢购列表
        { path: 'groupbuy_list', name: 'HomeGroupBuyList', component: resolve => (require(['@/components/home/groupbuy/GroupBuyList'], resolve)), meta: { footer: { show: false } } },
        // 虚拟抢购列表
        { path: 'vr_groupbuy_list', name: 'HomeVrGroupBuyList', component: resolve => (require(['@/components/home/vrgroupbuy/GroupBuyList'], resolve)), meta: { footer: { show: false } } },
        // 举报
        { path: 'report', name: 'Report', component: resolve => (require(['@/components/home/report/Report'], resolve)), meta: { footer: { show: false } } },
        // 公司介绍
        { path: 'about', name: 'About', component: resolve => (require(['@/components/home/about/aboutJiazi'], resolve)), meta: { footer: { show: false } } },
        //下列4个路由为新增的移动端页面
        { path: 'mobileMarketwheel', name: 'mobileMarketwheel', component: resolve => (require(['@/components/home/marketmanage/mobileMarketwheel'], resolve)), meta: { footer: { show: false } } },
        { path: 'mobileMarketegg', name: 'mobileMarketegg', component: resolve => (require(['@/components/home/marketmanage/mobileMarketegg'], resolve)), meta: { footer: { show: false } } },
        { path: 'mobileMarketzodiac', name: 'mobileMarketzodiac', component: resolve => (require(['@/components/home/marketmanage/mobileMarketzodiac'], resolve)), meta: { footer: { show: false } } },
        { path: 'mobileMarketcard', name: 'mobileMarketcard', component: resolve => (require(['@/components/home/marketmanage/mobileMarketcard'], resolve)), meta: { footer: { show: false } } },
        // 秒杀专区新增页面
        { path: 'miaosha', name: 'miaosha', component: resolve => (require(['@/components/home/miaosha/miaosha'], resolve)), meta: { footer: { show: false }, title: '秒杀专区' } },
      ]
    },

    {
      path: '/member/',
      component: MemberBase,
      children: [
        // 用户中心
        { path: 'index', name: 'MemberIndex', component: resolve => (require(['@/components/member/index/Index'], resolve)), meta: { footer: { show: true } } },
        // 我的钱包
        { path: 'account', name: 'MemberAccount', component: resolve => (require(['@/components/member/account/Account'], resolve)), meta: { footer: { show: true } } },
        // 退款退货
        { path: 'orderreturn', name: 'MemberOrderreturn', component: resolve => (require(['@/components/member/orderreturn/Orderreturn'], resolve)), meta: { footer: { show: true } } },
        // 资金明细
        { path: 'predeposit_list', name: 'MemberPredepositList', component: resolve => (require(['@/components/member/predeposit/PredepositList'], resolve)), meta: { footer: { show: true } } },
        // 充值卡明细
        { path: 'recharge_card_list', name: 'MemberRechargeCardList', component: resolve => (require(['@/components/member/predeposit/RechargeCardList'], resolve)), meta: { footer: { show: true } } },
        // 提现明细
        { path: 'withdraw_list', name: 'MemberWithdrawList', component: resolve => (require(['@/components/member/withdraw/WithdrawList'], resolve)), meta: { footer: { show: true } } },
        // 聊天信息
        { path: 'chat_info', name: 'MemberChatInfo', component: resolve => (require(['@/components/member/chat/ChatInfo'], resolve)), meta: { footer: { show: false } } },
        // 聊天列表
        { path: 'chat_list', name: 'MemberChatList', component: resolve => (require(['@/components/member/chat/ChatList'], resolve)), meta: { footer: { show: false } } },
        // 好友列表
        { path: 'friend_list', name: 'MemberFriendList', component: resolve => (require(['@/components/member/friend/FriendList'], resolve)), meta: { footer: { show: false } } },
        // 咨询列表
        { path: 'consult_list', name: 'MemberConsultList', component: resolve => (require(['@/components/member/consult/ConsultList'], resolve)), meta: { footer: { show: true } } },
        // 充值明细
        { path: 'recharge_list', name: 'MemberRechargeList', component: resolve => (require(['@/components/member/recharge/RechargeList'], resolve)), meta: { footer: { show: true } } },
        // 代金券列表
        { path: 'voucher_list', name: 'MemberVoucherList', component: resolve => (require(['@/components/member/voucher/VoucherList'], resolve)), meta: { footer: { show: true } } },
        // 消息列表
        { path: 'notice_list', name: 'MemberNoticeList', component: resolve => (require(['@/components/member/notice/NoticeList'], resolve)), meta: { footer: { show: true } } },
        // 账号设置
        { path: 'setting', name: 'MemberSetting', component: resolve => (require(['@/components/member/setting/AccountSet'], resolve)), meta: { footer: { show: true } } },
        // 个人信息
        { path: 'profile_set', name: 'MemberProfileSet', component: resolve => (require(['@/components/member/profile/ProfileSet'], resolve)), meta: { footer: { show: true } } },
        // 积分明细
        { path: 'point_list', name: 'MemberPointList', component: resolve => (require(['@/components/member/point/PointList'], resolve)), meta: { footer: { show: true } } },
        // 签到送积分
        { path: 'point_signin', name: 'MemberPointSignin', component: resolve => (require(['@/components/member/point/PointSignin'], resolve)), meta: { footer: { show: true } } },
        // 地址列表
        { path: 'address_list', name: 'MemberAddressList', component: resolve => (require(['@/components/member/address/AddressList'], resolve)), meta: { footer: { show: true } } },
        // 地址编辑
        { path: 'address_form', name: 'MemberAddressForm', component: resolve => (require(['@/components/member/address/AddressForm'], resolve)), meta: { footer: { show: true } } },
        // 提现账户列表
        { path: 'bank_list', name: 'MemberBankList', component: resolve => (require(['@/components/member/bank/BankList'], resolve)), meta: { footer: { show: true } } },
        // 提现账户编辑
        { path: 'bank_form', name: 'MemberBankForm', component: resolve => (require(['@/components/member/bank/BankForm'], resolve)), meta: { footer: { show: true } } },
        // 退款列表
        { path: 'refund_list', name: 'MemberRefundList', component: resolve => (require(['@/components/member/refund/RefundList'], resolve)), meta: { footer: { show: true } } },
        // 退款编辑
        { path: 'refund_form', name: 'MemberRefundForm', component: resolve => (require(['@/components/member/refund/RefundForm'], resolve)), meta: { footer: { show: true } } },
        // 退款详情
        { path: 'refund_view', name: 'MemberRefundView', component: resolve => (require(['@/components/member/refund/RefundView'], resolve)), meta: { footer: { show: true } } },
        // 退款列表
        { path: 'vrrefund_list', name: 'MemberVrRefundList', component: resolve => (require(['@/components/member/vrrefund/VrRefundList'], resolve)), meta: { footer: { show: true } } },
        // 退款编辑
        { path: 'vrrefund_form', name: 'MemberVrRefundForm', component: resolve => (require(['@/components/member/vrrefund/VrRefundForm'], resolve)), meta: { footer: { show: true } } },
        // 退款详情
        { path: 'vrrefund_view', name: 'MemberVrRefundView', component: resolve => (require(['@/components/member/vrrefund/VrRefundView'], resolve)), meta: { footer: { show: true } } },
        // 退货列表
        { path: 'return_list', name: 'MemberReturnList', component: resolve => (require(['@/components/member/return/ReturnList'], resolve)), meta: { footer: { show: true } } },
        // 退货编辑
        { path: 'return_form', name: 'MemberReturnForm', component: resolve => (require(['@/components/member/return/ReturnForm'], resolve)), meta: { footer: { show: true } } },
        // 退货详情
        { path: 'return_view', name: 'MemberReturnView', component: resolve => (require(['@/components/member/return/ReturnView'], resolve)), meta: { footer: { show: true } } },
        // 退货
        { path: 'return_send', name: 'MemberReturnSend', component: resolve => (require(['@/components/member/return/ReturnSend'], resolve)), meta: { footer: { show: true } } },
        // 发票列表
        { path: 'invoice_list', name: 'MemberInvoiceList', component: resolve => (require(['@/components/member/invoice/InvoiceList'], resolve)), meta: { footer: { show: true } } },
        // 发票编辑
        { path: 'invoice_form', name: 'MemberInvoiceForm', component: resolve => (require(['@/components/member/invoice/InvoiceForm'], resolve)), meta: { footer: { show: true } } },
        // 下单界面
        { path: 'buystep1', name: 'MemberBuyStep1', component: resolve => (require(['@/components/member/buy/step1'], resolve)), meta: { footer: { show: false } } },
        // 下单界面
        { path: 'vrbuystep1', name: 'MemberVrBuyStep1', component: resolve => (require(['@/components/member/vrbuy/step1'], resolve)), meta: { footer: { show: false } } },
        // 积分商品下单
        { path: 'pointsbuystep1', name: 'MemberPointsBuyStep1', component: resolve => (require(['@/components/member/pointsbuy/step1'], resolve)), meta: { footer: { show: false } } },
        // 积分商品购物车
        { path: 'pointscart', name: 'MemberPointsCart', component: resolve => (require(['@/components/member/pointscart/Cart'], resolve)), meta: { footer: { show: true } } },
        // 积分订单列表
        { path: 'pointsorder_list', name: 'MemberPointsOrderList', component: resolve => (require(['@/components/member/pointsorder/OrderList'], resolve)), meta: { footer: { show: true } } },
        // 积分订单详情
        { path: 'pointsorder_detail', name: 'MemberPointsOrderDetail', component: resolve => (require(['@/components/member/pointsorder/OrderDetail'], resolve)), meta: { footer: { show: true } } },
        // 商家投诉
        { path: 'inform_list', name: 'MemberInformList', component: resolve => (require(['@/components/member/inform/InformList'], resolve)), meta: { footer: { show: true } } },
        // 商家投诉
        { path: 'inform_form', name: 'MemberInformForm', component: resolve => (require(['@/components/member/inform/InformForm'], resolve)), meta: { footer: { show: true } } },
        // 商家投诉
        { path: 'complaint_list', name: 'MemberComplaintList', component: resolve => (require(['@/components/member/complaint/ComplaintList'], resolve)), meta: { footer: { show: true } } },
        // 商家投诉
        { path: 'complaint_form', name: 'MemberComplaintForm', component: resolve => (require(['@/components/member/complaint/ComplaintForm'], resolve)), meta: { footer: { show: true } } },
        // 支付界面
        { path: 'buypay', name: 'MemberBuyPay', component: resolve => (require(['@/components/member/buy/pay'], resolve)), meta: { footer: { show: false } } },
        // 我的订单
        { path: 'order_list', name: 'MemberOrderList', component: resolve => (require(['@/components/member/order/OrderList'], resolve)), meta: { footer: { show: true } } },
        // 我的收藏
        { path: 'favorite', name: 'MemberFavorite', component: resolve => (require(['@/components/member/favorite/Favorite'], resolve)), meta: { footer: { show: true } } },


        // 订单详情
        { path: 'order_detail', name: 'MemberOrderDetail', component: resolve => (require(['@/components/member/order/OrderDetail'], resolve)), meta: { footer: { show: true } } },
        // 物流跟踪
        { path: 'order_deliver', name: 'MemberOrderDeliver', component: resolve => (require(['@/components/member/order/OrderDeliver'], resolve)), meta: { footer: { show: true } } },
        // 评价订单
        { path: 'order_evaluate', name: 'MemberOrderEvaluate', component: resolve => (require(['@/components/member/order/OrderEvaluate'], resolve)), meta: { footer: { show: true } } },
        // 订单详情
        { path: 'vrorder_detail', name: 'MemberVrOrderDetail', component: resolve => (require(['@/components/member/vrorder/OrderDetail'], resolve)), meta: { footer: { show: true } } },
        // 评价订单
        { path: 'vrorder_evaluate', name: 'MemberVrOrderEvaluate', component: resolve => (require(['@/components/member/vrorder/OrderEvaluate'], resolve)), meta: { footer: { show: true } } },
        // 我的订单
        { path: 'vrorder_list', name: 'MemberVrOrderList', component: resolve => (require(['@/components/member/vrorder/OrderList'], resolve)), meta: { footer: { show: true } } },

        // 用户订单评价列表
        { path: 'evaluate_list', name: 'MemberEvaluateList', component: resolve => (require(['@/components/member/evaluate/EvaluateList'], resolve)), meta: { footer: { show: true } } },
        // 推广海报
        { path: 'inviter_manage', name: 'MemberInviterManage', component: resolve => (require(['@/components/member/inviter/InviterManage'], resolve)), meta: { footer: { show: true } } },
        // 推广会员
        { path: 'inviter_user', name: 'MemberInviterUser', component: resolve => (require(['@/components/member/inviter/InviterUser'], resolve)), meta: { footer: { show: true } } },
        // 推广佣金
        { path: 'inviter_order', name: 'MemberInviterOrder', component: resolve => (require(['@/components/member/inviter/InviterOrder'], resolve)), meta: { footer: { show: true } } },
        // 推广详情
        { path: 'Inviter_detail', name: 'MemberInviterDetail', component: resolve => (require(['@/components/member/inviter/InviterDetail'], resolve)), meta: { footer: { show: true } } },


        // 活动记录
        { path: 'marketmanagelog', name: 'MemberMarketmanagelog', component: resolve => (require(['@/components/member/marketmanagelog/Marketmanagelog'], resolve)), meta: { footer: { show: true } } },
        // 红包领取记录
        { path: 'bonusreceive', name: 'MemberBonusreceive', component: resolve => (require(['@/components/member/bonusreceive/Bonusreceive'], resolve)), meta: { footer: { show: true } } },
        // 砍价列表页
        { path: 'bargain_list', name: 'MemberBargainlist', component: resolve => (require(['@/components/member/bargain/Bargainlist'], resolve)), meta: { footer: { show: true } } },
        // 到货通知页面
        { path: 'arrivalnotice', name: 'MemberArrivalnotice', component: resolve => (require(['@/components/member/arrivalnotice/Arrivalnotice'], resolve)), meta: { footer: { show: true } } },
        // 浏览历史页面
        { path: 'browse_list', name: 'MemberBrowseList', component: resolve => (require(['@/components/member/browse/BrowseList'], resolve)), meta: { footer: { show: true } } },
        // 意见反馈
        { path: 'feedback', name: 'MemberFeedback', component: resolve => (require(['@/components/member/feedback/Feedback'], resolve)), meta: { footer: { show: true } } },
        // 会员认证页面
        { path: 'auth', name: 'MemberAuth', component: resolve => (require(['@/components/member/auth/Auth'], resolve)), meta: { footer: { show: true } } },
        // 直播详情
        { path: 'live_detail', name: 'MemberLiveDetail', component: resolve => (require(['@/components/member/live/LiveDetail'], resolve)), meta: { footer: { show: false } } },
        // 直播列表
        { path: 'live_list', name: 'MemberLiveList', component: resolve => (require(['@/components/member/live/LiveList'], resolve)), meta: { footer: { show: false } } },
        // 店铺入驻
        { path: 'seller_joinin_1', name: 'SellerJoinin1', component: resolve => (require(['@/components/member/sellerjoinin/Step1'], resolve)), meta: { footer: { show: true } } },
        // 店铺入驻
        { path: 'seller_joinin_2', name: 'SellerJoinin2', component: resolve => (require(['@/components/member/sellerjoinin/Step2'], resolve)), meta: { footer: { show: true } } },
        // 店铺入驻
        { path: 'seller_joinin_3', name: 'SellerJoinin3', component: resolve => (require(['@/components/member/sellerjoinin/Step3'], resolve)), meta: { footer: { show: true } } },
        // 店铺入驻
        { path: 'seller_joinin_4', name: 'SellerJoinin4', component: resolve => (require(['@/components/member/sellerjoinin/Step4'], resolve)), meta: { footer: { show: true } } },
        // 店铺入驻
        { path: 'seller_joinin_5', name: 'SellerJoinin5', component: resolve => (require(['@/components/member/sellerjoinin/Step5'], resolve)), meta: { footer: { show: true } } },
        { path: 'sign', name: 'sign', component: resolve => (require(['@/components/member/sign/sign'], resolve)), meta: { footer: { show: false } } },
        { path: 'sign_order', name: 'sign_order', component: resolve => (require(['@/components/member/sign/orders'], resolve)), meta: { footer: { show: false } } },
        { path: 'sign_order_detail', name: 'sign_order_detail', component: resolve => (require(['@/components/member/sign/detail'], resolve)), meta: { footer: { show: false } } }
      ]
    },
    {
      path: '/seller/',
      component: SellerBase,
      children: [
        // 卖家中心
        { path: 'index', name: 'SellerIndex', component: resolve => (require(['@/components/seller/index/Index'], resolve)), meta: { footer: { show: true } } },
        // 咨询列表
        { path: 'consult_list', name: 'SellerConsultList', component: resolve => (require(['@/components/seller/consult/ConsultList'], resolve)), meta: { footer: { show: true } } },
        // 聊天信息
        { path: 'chat_info', name: 'SellerChatInfo', component: resolve => (require(['@/components/seller/chat/ChatInfo'], resolve)), meta: { footer: { show: false } } },
        // 聊天列表
        { path: 'chat_list', name: 'SellerChatList', component: resolve => (require(['@/components/seller/chat/ChatList'], resolve)), meta: { footer: { show: false } } },
        // 店铺发货地址列表
        { path: 'address_list', name: 'SellerAddressList', component: resolve => (require(['@/components/seller/address/AddressList'], resolve)), meta: { footer: { show: true } } },
        // 编辑店铺发货地址
        { path: 'address_form', name: 'SellerAddressForm', component: resolve => (require(['@/components/seller/address/AddressForm'], resolve)), meta: { footer: { show: true } } },
        // 店铺消息列表
        { path: 'notice_list', name: 'SellerNoticeList', component: resolve => (require(['@/components/seller/notice/NoticeList'], resolve)), meta: { footer: { show: true } } },
        // 代金券列表
        { path: 'voucher_list', name: 'SellerVoucherList', component: resolve => (require(['@/components/seller/voucher/VoucherList'], resolve)), meta: { footer: { show: true } } },
        // 编辑代金券
        { path: 'voucher_form', name: 'SellerVoucherForm', component: resolve => (require(['@/components/seller/voucher/VoucherForm'], resolve)), meta: { footer: { show: true } } },
        // 卖家商品管理
        { path: 'goodsonline', name: 'SellerGoodsonline', component: resolve => (require(['@/components/seller/goods/Goodsonline'], resolve)), meta: { footer: { show: true } } },
        // 卖家商品上传步骤1
        { path: 'goods_form_1', name: 'SellerGoodsForm1', component: resolve => (require(['@/components/seller/goods/GoodsForm1'], resolve)), meta: { footer: { show: true } } },
        // 卖家商品上传步骤2
        { path: 'goods_form_2', name: 'SellerGoodsForm2', component: resolve => (require(['@/components/seller/goods/GoodsForm2'], resolve)), meta: { footer: { show: true } } },
        // 卖家商品上传步骤3
        { path: 'goods_form_3', name: 'SellerGoodsForm3', component: resolve => (require(['@/components/seller/goods/GoodsForm3'], resolve)), meta: { footer: { show: true } } },
        // 退款列表
        { path: 'refund_list', name: 'SellerRefundList', component: resolve => (require(['@/components/seller/refund/RefundList'], resolve)), meta: { footer: { show: true } } },
        // 退款编辑
        { path: 'refund_form', name: 'SellerRefundForm', component: resolve => (require(['@/components/seller/refund/RefundForm'], resolve)), meta: { footer: { show: true } } },
        // 退款详情
        { path: 'refund_view', name: 'SellerRefundView', component: resolve => (require(['@/components/seller/refund/RefundView'], resolve)), meta: { footer: { show: true } } },
        // 物流跟踪
        { path: 'refund_deliver', name: 'SellerRefundDeliver', component: resolve => (require(['@/components/seller/refund/RefundDeliver'], resolve)), meta: { footer: { show: true } } },
        // 评价列表
        { path: 'evaluate_list', name: 'SellerEvaluateList', component: resolve => (require(['@/components/seller/evaluate/EvaluateList'], resolve)), meta: { footer: { show: true } } },
        // 卖家订单列表
        { path: 'orderlist', name: 'SellerOrderList', component: resolve => (require(['@/components/seller/order/OrderList'], resolve)), meta: { footer: { show: true } } },
        // 订单详情
        { path: 'order_detail', name: 'SellerOrderDetail', component: resolve => (require(['@/components/seller/order/OrderDetail'], resolve)), meta: { footer: { show: true } } },
        // 物流跟踪
        { path: 'order_deliver', name: 'SellerOrderDeliver', component: resolve => (require(['@/components/seller/order/OrderDeliver'], resolve)), meta: { footer: { show: true } } },
        // 订单发货
        { path: 'order_send', name: 'SellerOrderSend', component: resolve => (require(['@/components/seller/order/OrderSend'], resolve)), meta: { footer: { show: true } } },
        // 订单详情
        { path: 'vrorder_detail', name: 'SellerVrOrderDetail', component: resolve => (require(['@/components/seller/vrorder/OrderDetail'], resolve)), meta: { footer: { show: true } } },
        // 我的订单
        { path: 'vrorder_list', name: 'SellerVrOrderList', component: resolve => (require(['@/components/seller/vrorder/OrderList'], resolve)), meta: { footer: { show: true } } },
        // 卖家结算单
        { path: 'billlist', name: 'SellerBillList', component: resolve => (require(['@/components/seller/bill/BillList'], resolve)), meta: { footer: { show: true } } },
        // 商家投诉
        { path: 'complaint_list', name: 'SellerComplaintList', component: resolve => (require(['@/components/seller/complaint/ComplaintList'], resolve)), meta: { footer: { show: true } } },
        // 商家投诉
        { path: 'complaint_form', name: 'SellerComplaintForm', component: resolve => (require(['@/components/seller/complaint/ComplaintForm'], resolve)), meta: { footer: { show: true } } },
        // 店铺概况
        { path: 'statistics_general', name: 'SellerStatisticsGeneral', component: resolve => (require(['@/components/seller/statisticsgeneral/Index'], resolve)), meta: { footer: { show: true } } },
        // 店铺基本信息设置管理页
        { path: 'setting_index', name: 'SellerSettingIndex', component: resolve => (require(['@/components/seller/setting/Index'], resolve)), meta: { footer: { show: true } } },
        // 店铺基本信息设置
        { path: 'setting_info', name: 'SellerSettingInfo', component: resolve => (require(['@/components/seller/setting/Info'], resolve)), meta: { footer: { show: true } } },
        // 店铺分销页面
        { path: 'inviter', name: 'SellerInviter', component: resolve => (require(['@/components/seller/inviter/Index'], resolve)), meta: { footer: { show: true } } },
        // 分销订单管理
        { path: 'inviter_orderlist', name: 'SellerInviterOrderList', component: resolve => (require(['@/components/seller/inviter/OrderList'], resolve)), meta: { footer: { show: true } } },
        // 分销商品管理
        { path: 'inviter_goodslist', name: 'SellerInviterGoodsList', component: resolve => (require(['@/components/seller/inviter/GoodsList'], resolve)), meta: { footer: { show: true } } },
        // 分销商品添加/编辑
        { path: 'inviter_goodsform', name: 'SellerInviterGoodsForm', component: resolve => (require(['@/components/seller/inviter/GoodsForm'], resolve)), meta: { footer: { show: true } } },
        // 子账户管理界面
        { path: 'account', name: 'SellerAccount', component: resolve => (require(['@/components/seller/account/Index'], resolve)), meta: { footer: { show: true } } },
        // 子账户列表
        { path: 'account_list', name: 'SellerAccountList', component: resolve => (require(['@/components/seller/account/AccountList'], resolve)), meta: { footer: { show: true } } },
        // 添加子账户
        { path: 'account_form', name: 'SellerAccountForm', component: resolve => (require(['@/components/seller/account/AccountForm'], resolve)), meta: { footer: { show: true } } },
        // 账户组列表
        { path: 'accountgroup_list', name: 'SellerAccountGroupList', component: resolve => (require(['@/components/seller/accountgroup/AccountGroupList'], resolve)), meta: { footer: { show: true } } },
        // 账户组列表
        { path: 'accountgroup_form', name: 'SellerAccountGroupForm', component: resolve => (require(['@/components/seller/accountgroup/AccountGroupForm'], resolve)), meta: { footer: { show: true } } },
        // 账户组列表
        { path: 'goodsclass_list', name: 'SellerGoodsClassList', component: resolve => (require(['@/components/seller/goodsclass/GoodsClassList'], resolve)), meta: { footer: { show: true } } },
        // 账户组列表
        { path: 'goodsclass_form', name: 'SellerGoodsClassForm', component: resolve => (require(['@/components/seller/goodsclass/GoodsClassForm'], resolve)), meta: { footer: { show: true } } },
        // 账户日志记录
        { path: 'log_list', name: 'SellerLogList', component: resolve => (require(['@/components/seller/log/LogList'], resolve)), meta: { footer: { show: true } } },
        // 账户消费记录
        { path: 'cost_list', name: 'SellerCostList', component: resolve => (require(['@/components/seller/cost/CostList'], resolve)), meta: { footer: { show: true } } },
        // 店铺资金
        { path: 'money', name: 'SellerMoney', component: resolve => (require(['@/components/seller/money/Index'], resolve)), meta: { footer: { show: true } } },
        // 店铺资金记录
        { path: 'moneylog_list', name: 'SellerMoneyLogList', component: resolve => (require(['@/components/seller/money/LogList'], resolve)), meta: { footer: { show: true } } },
        // 店铺资金提现记录
        { path: 'moneywithdraw_list', name: 'SellerMoneyWithdrawList', component: resolve => (require(['@/components/seller/money/WithdrawList'], resolve)), meta: { footer: { show: true } } },
        // 店铺保证金
        { path: 'deposit', name: 'SellerDeposit', component: resolve => (require(['@/components/seller/deposit/Index'], resolve)), meta: { footer: { show: true } } },
        // 店铺保证金记录
        { path: 'deposit_list', name: 'SellerDepositList', component: resolve => (require(['@/components/seller/deposit/DepositList'], resolve)), meta: { footer: { show: true } } },
        // 店铺保证金提现记录
        { path: 'depositwithdraw_list', name: 'SellerDepositWithdrawList', component: resolve => (require(['@/components/seller/deposit/WithdrawList'], resolve)), meta: { footer: { show: true } } },
        // 店铺售卖区域
        { path: 'transport_list', name: 'SellerTransportList', component: resolve => (require(['@/components/seller/transport/transportList'], resolve)), meta: { footer: { show: true } } },
        // 店铺售卖区域
        { path: 'transport_form', name: 'SellerTransportForm', component: resolve => (require(['@/components/seller/transport/transportForm'], resolve)), meta: { footer: { show: true } } },
        // 直播
        { path: 'live_apply_list', name: 'SellerLiveApplyList', component: resolve => (require(['@/components/seller/live_apply/LiveApplyList'], resolve)), meta: { footer: { show: true } } },
        // 直播
        { path: 'live_apply_form', name: 'SellerLiveApplyForm', component: resolve => (require(['@/components/seller/live_apply/LiveApplyForm'], resolve)), meta: { footer: { show: true } } }
      ]
    }
  ]
})
